// import { gsap } from "gsap/gsap-core";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

/* global gsap, ScrollTrigger: false */

gsap.registerPlugin(ScrollTrigger);


export default class FadeInEffect {
	constructor(element) {
		if (!element) return;
		this.el = element;
		this.init();
	}

	init() {
		gsap.fromTo(
			this.el,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				duration: 2,
				delay: this.el.dataset?.animDelay || 0,
				scrollTrigger: {
					trigger: this.el,
					once: false,
					toggleActions: "play none none none",
					start: "top 95%",
				},
			}
		);
	}
}
